module.exports = __webpack_public_path__ + "static/media/LogoCCT.aa94c97e.svg";